var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.7349,
    height: 17.7349,
    rx: 8.86743,
    fill: "#AAAAB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23656 12.4438L5.54688 11.7541L8.30563 8.99532L5.54688 6.23656L6.23656 5.54688L8.99532 8.30563L11.7541 5.54688L12.4438 6.23656L9.68501 8.99532L12.4438 11.7541L11.7541 12.4438L8.99532 9.68501L6.23656 12.4438Z",
    fill: "#FBFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.f3315f1d.svg";
export { ForwardRef as ReactComponent };